export const HIGHEST_GAINER = "HIGHEST_GAINER";
export const HIGHEST_GAINER_STREAM = "HIGHEST_GAINER_STREAM";
